import React from 'react';
import { UpdateBotToolSettingsRequest } from "../../../../../../../../api/generated";
import { SelectDropdown, SelectOption } from "../../../../../../../elements/select/SelectDropdown";
import { MultiSelectDropdown } from "../../../../../../../elements/multiSelect/MultiSelectDropdown";
import { ValidatedInputField } from "../../../../../../../elements/validator/component/ValidatedInputField";
import { NotEmptyStringValidator, FloatNumberValidator, RegexPatternValidator } from "../../../../../../../elements/validator/Validator";
import { ValidationResult } from "../../../../../../../elements/validator/component/ValidationComponent";
import { RootState } from "../../../../../../../../app/store";
import styles from "./Condition.module.css";

interface ConditionValueInputProps {
    conditionValues?: string[];
    requiresMultiValue: boolean;
    isEnumField: boolean;
    isNumericField: boolean;
    isRegexOperator: boolean;
    enumValueOptions: SelectOption<string>[];
    fieldName: keyof UpdateBotToolSettingsRequest;
    conditionValueSelector: (state: RootState) => string | undefined;
    conditionValueAsNumberSelector: (state: RootState) => number | undefined;
    disabled?: boolean;
    updateValidationStatus: (status: ValidationResult<UpdateBotToolSettingsRequest>) => void;
    getMessageWrapper: (f: string) => string;
    onValueChange: (value: string) => void;
    onMultiValueChange: (values: string[]) => void;
}

export const ConditionValueInput: React.FC<ConditionValueInputProps> = ({
    conditionValues,
    requiresMultiValue,
    isEnumField,
    isNumericField,
    isRegexOperator,
    enumValueOptions,
    fieldName,
    conditionValueSelector,
    conditionValueAsNumberSelector,
    disabled,
    updateValidationStatus,
    getMessageWrapper,
    onValueChange,
    onMultiValueChange
}) => {
    const getMultiValueArray = (): string[] => {
        if (!conditionValues || conditionValues.length === 0) return [];
        return conditionValues;
    };

    if (requiresMultiValue) {
        if (isEnumField) {
            return (
                <MultiSelectDropdown
                    title=""
                    value={getMultiValueArray()}
                    handleChange={onMultiValueChange}
                    options={enumValueOptions}
                    disabled={disabled}
                    isEqual={(a, b) => a === b}
                />
            );
        }

        return (
            <div className={isRegexOperator ? styles.monoValue : ''}>
                <ValidatedInputField<string, UpdateBotToolSettingsRequest>
                    validator={isRegexOperator ? RegexPatternValidator : NotEmptyStringValidator}
                    selector={conditionValueSelector}
                    fieldName={fieldName}
                    onChange={onValueChange}
                    updateValidationStatus={updateValidationStatus}
                    label=""
                    placeholder={isRegexOperator ? "Enter regex pattern" : "Enter values (comma-separated)"}
                    disabled={disabled}
                    required={false}
                    getMessage={getMessageWrapper}
                />
            </div>
        );
    }

    if (isEnumField) {
        return (
            <SelectDropdown
                title=""
                value={conditionValues && conditionValues.length > 0 ? conditionValues[0] : ''}
                options={enumValueOptions}
                handleChange={onValueChange}
                disabled={disabled}
                selectFirstOptionByDefault={false}
            />
        );
    }

    if (isNumericField) {
        return (
            <ValidatedInputField<number, UpdateBotToolSettingsRequest>
                validator={FloatNumberValidator}
                selector={conditionValueAsNumberSelector}
                fieldName={fieldName}
                onChange={(v) => onValueChange(v?.toString() || '')}
                updateValidationStatus={updateValidationStatus}
                label=""
                placeholder="Enter number"
                disabled={disabled}
                required={false}
                getMessage={getMessageWrapper}
            />
        );
    }

    return (
        <div className={isRegexOperator ? styles.monoValue : ''}>
            <ValidatedInputField<string, UpdateBotToolSettingsRequest>
                validator={isRegexOperator ? RegexPatternValidator : NotEmptyStringValidator}
                selector={conditionValueSelector}
                fieldName={fieldName}
                onChange={onValueChange}
                updateValidationStatus={updateValidationStatus}
                label=""
                placeholder={isRegexOperator ? "Enter regex pattern" : "Enter value"}
                disabled={disabled}
                required={false}
                getMessage={getMessageWrapper}
            />
        </div>
    );
};

